import { DisplayControlGroup } from 'features/DisplayControlGroup/models';
import axiosClient from 'utils/axiosClient';

export interface Response {
  status: string;
  message: string;
  data: DisplayControlGroup[];
}

const service = {
  async get(): Promise<Response> {
    const url = `control-group-menu/list/`;
    return await axiosClient.get(url);
  },
  checkDelete(ids: string): Promise<Response> {
    const idsArray = ids.split(',').map((id) => parseInt(id, 10));
    const body = JSON.stringify({ ids: idsArray });
    const url = `control-group-menu/check-delete/`;
    return axiosClient.post(url, body);
  },
  delete(ids: string, idsExact: number[]): Promise<Response> {
    const idsArray = ids.split(',').map((id) => parseInt(id, 10));
    const body = JSON.stringify({ ids: idsArray, idsExact: idsExact });
    const url = `control-group-menu/delete/`;
    return axiosClient.delete(url, { data: body });
  },
  restore(id: number): Promise<Response> {
    const ids = [id];
    const body = JSON.stringify({ ids: ids });
    const url = `control-group-menu/undelete/`;
    return axiosClient.put(url, body);
  },
};

export default service;
